import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { Toaster } from 'react-hot-toast'

import App from './App.tsx'
import { theme } from './theme/theme.ts'
import { AuthProvider } from './auth/AuthProvider.tsx'
import { LoadingProvider, useLoading } from './contexts/LoadingContext.tsx'
import LoadingSpinner from './components/LoadingSpinner/LoadingSpinner.tsx'

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Wrapper component to include LoadingSpinner
const AppWithLoading: React.FC = () => {
  const { isLoading, loadingMessage } = useLoading()
  
  return (
    <>
      <App />
      <LoadingSpinner isVisible={isLoading} message={loadingMessage} />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
    </>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <LoadingProvider>
            <AuthProvider>
              <AppWithLoading />
            </AuthProvider>
          </LoadingProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
